import * as tslib_1 from "tslib";
import _ from 'lodash';
import { Durations, AssetType, OrderAction, PositionEffect, OrderActionDirection, SizeRatio, } from '@tradingblock/types';
import { tryValidate, SchemaValidator } from './strategyValidator';
export const baseOccPattern = (optionType = 'PC') => new RegExp('([\\s]{3})([\\w]{3,6})(\\d{2})(\\d{2})(\\d{2})([' + optionType + '])(\\d{5,8})');
//export const occSymbolPattern = /([\s]{3})([\w]{3,6})(\d{2})(\d{2})(\d{2})([PC])(\d{5,8})/g;
export const occSymbolPattern = baseOccPattern();
export const legSchemaBuilder = ({ spreadRatio, assetType, action, optionType }, sizeRatio) => {
    let requiredFields = ['UnderlyingSymbol', 'AssetType', 'Action', 'PositionEffect', 'Symbol'];
    if (assetType === AssetType.Option) {
        requiredFields = [...requiredFields, 'Expiration', 'Strike'];
    }
    const isSpread = sizeRatio !== SizeRatio.NA;
    if (isSpread) {
        requiredFields = [...requiredFields, 'SpreadRatio'];
    }
    const legSchema = {
        type: 'object',
        required: requiredFields,
        properties: {
            UnderlyingSymbol: { type: 'string' },
            SpreadRatio: isSpread ? { type: 'number' } : { anyOf: [{ type: 'number' }, { const: undefined }] },
            AssetType: { enum: _.isArray(assetType) ? assetType : [assetType] },
            Strike: assetType === AssetType.Option ? { type: 'number' } : { const: undefined },
            Action: _.isArray(action) ? { enum: action } : { type: 'number' },
            PositionEffect: {
                enum: [PositionEffect.Open, PositionEffect.Close],
            },
            // Strike: assetType === AssetType.Option ? { type: 'number' } : undefined,
            Symbol: {
                type: 'string',
            },
            OptionType: { const: optionType },
        },
    };
    return legSchema;
};
const orderSchemaBuilder = (orderClass, legSchema, spreadRatio, moreProperties) => {
    const _a = _.merge(moreProperties, {
        Strike: undefined,
        Expiration: undefined,
        Direction: undefined,
    }), { Strike, Expiration, Direction } = _a, rest = tslib_1.__rest(_a, ["Strike", "Expiration", "Direction"]);
    return {
        required: ['OrderClass', 'Duration', 'Legs'],
        properties: Object.assign({ OrderClass: {
                const: orderClass,
            }, Duration: {
                enum: [Durations.GTC, Durations.Day, Durations.Manual],
            }, Legs: {
                minItems: legSchema.length,
                maxItems: legSchema.length,
                type: 'array',
                items: _.map(legSchema, l => legSchemaBuilder(l, spreadRatio)),
                strike: Strike,
                expiration: Expiration,
                ratio: spreadRatio,
                action: Direction,
            } }, (rest || {})),
    };
};
function isActionLegSchema(val) {
    if (val && _.get(val, 'action', false)) {
        return true;
    }
    return false;
}
const buildValidationSchemas = (strategy) => {
    const legsDef = _.map(strategy.profile.Legs, l => {
        const legSchem = {
            assetType: l.AssetType,
            spreadRatio: l.SpreadRatio,
            optionType: l.OptionType,
        };
        if (l.Direction) {
            return Object.assign({}, legSchem, { action: l.Direction === OrderActionDirection.Long ? OrderAction.Buy : OrderAction.Sell });
        }
        return legSchem;
    });
    const additionalRules = strategy.profile.Rules
        ? {
            Strike: strategy.profile.Rules.Strike,
            Expiration: strategy.profile.Rules.Expiration,
            Direction: strategy.profile.Rules.Direction,
        }
        : {};
    const orderSchema = orderSchemaBuilder(strategy.profile.OrderClass, legsDef, strategy.profile.Rules.SpreadRatio, additionalRules);
    const inverseOrderSchema = strategy.profile.Bidirectional
        ? orderSchemaBuilder(strategy.profile.OrderClass, legsDef.map(ll => {
            if (isActionLegSchema(ll)) {
                return Object.assign({}, ll, { action: ll.action === OrderAction.Buy ? OrderAction.Sell : OrderAction.Buy });
            }
            return ll;
        }), strategy.profile.Rules.SpreadRatio, additionalRules)
        : undefined;
    return { buySchema: orderSchema, sellSchema: inverseOrderSchema };
};
export const tryValidateOrderForStrategy = (ajv, strategy, order) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    const schemas = buildValidationSchemas(strategy);
    let [validationResults, inverseValidationResults] = yield Promise.all([
        tryValidate(ajv, schemas.buySchema, order),
        schemas.sellSchema ? tryValidate(ajv, schemas.sellSchema, order) : Promise.resolve(undefined),
    ]);
    return {
        order,
        sell: {
            isValid: inverseValidationResults && inverseValidationResults.valid ? true : false,
            results: inverseValidationResults,
        },
        buy: {
            isValid: validationResults && validationResults.valid ? true : false,
            results: validationResults,
        },
    };
});
export const tryValidateOrder = (ajv, strategy, order) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    const schemas = buildValidationSchemas(strategy);
    let res = yield tryValidate(ajv, schemas.buySchema, order);
    let inverse = schemas.sellSchema ? yield tryValidate(ajv, schemas.sellSchema, order) : undefined;
    let isVal = res.valid ? res.valid : inverse ? inverse.valid : false;
    const isInverseValid = isVal && inverse && inverse.valid ? true : false;
    // console.log(strategy.info.Name, res, inverse);
    return {
        isInverse: isInverseValid,
        valid: isVal,
        validationResults: res,
        inverseValidationResults: inverse,
    };
});
export const validateOrder = (strategy, order) => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield tryValidateOrder(SchemaValidator(), strategy, order); });
export const validateOrderForStrategy = (strategy, order) => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield tryValidateOrderForStrategy(SchemaValidator(), strategy, order); });
export const isValid = (strategy, order) => tslib_1.__awaiter(this, void 0, void 0, function* () {
    return yield validateOrder(strategy, order).then(res => res.valid);
});
//# sourceMappingURL=validation.js.map